// extracted by mini-css-extract-plugin
export default {"Header__Section":"Gdpr_Header__Section__GorXd","Protection__Page__Wrapper":"Gdpr_Protection__Page__Wrapper__tB+uN","Page__Title":"Gdpr_Page__Title__6LvS-"};